import { useAppSelector } from 'application/providers/StoreProvider';
import { selectAccountLoading } from 'application/store/slices/accountSlice/selectors';

export const useAccountLoading = () => {
  const loading = useAppSelector(selectAccountLoading);

  return loading;
};
